// F2-a (D1): client cloud SEPARATO dal client Pi (client.ts).
//
// L'owner parla con api-cloud (default :3002) tramite cookie HttpOnly
// `hm_owner_at`, un'origine/auth distinta dall'operatore↔Pi (client.ts,
// cookie operatore su :3001). Tenerli separati evita confusione di
// cookie/base URL. NON tocca il client Pi esistente.
//
// Riusa la classe ApiError da client.ts per uniformità di error handling.
import { ApiError } from './client.js';

const CLOUD_API_URL = import.meta.env.VITE_CLOUD_API_URL ?? 'http://localhost:3002';

// Handler globale 401 owner: su sessione cloud scaduta/assente, la UI
// owner deve tornare a /owner/login. Settato dal boot (App.tsx), distinto
// dall'handler operatore di client.ts.
type UnauthorizedHandler = (path: string) => void;
let onOwnerUnauthorized: UnauthorizedHandler | null = null;

export function setOwnerUnauthorizedHandler(handler: UnauthorizedHandler | null): void {
  onOwnerUnauthorized = handler;
}

export async function cloudApi<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${CLOUD_API_URL}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
    ...init,
  });
  let body: unknown = null;
  const text = await res.text();
  if (text) {
    try {
      body = JSON.parse(text);
    } catch {
      body = text;
    }
  }
  if (!res.ok) {
    const code =
      typeof body === 'object' && body !== null && 'error' in body
        ? String((body as { error: unknown }).error)
        : undefined;
    // 401 globale owner: notify handler, ma NON sulla login stessa, dove
    // 401 e' il segnale legittimo (credenziali errate / totp_required) e
    // va gestito dalla UI di login senza redirigersi.
    if (res.status === 401 && onOwnerUnauthorized && !isOwnerLoginPath(path)) {
      onOwnerUnauthorized(path);
    }
    throw new ApiError(res.status, res.statusText || `HTTP ${res.status}`, code, body);
  }
  return body as T;
}

function isOwnerLoginPath(path: string): boolean {
  return path.startsWith('/auth/owner-login');
}
